// Generated by purs version 0.13.8
"use strict";
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Capability_Navigate = require("../Lunarbox.Capability.Navigate/index.js");
var Lunarbox_Capability_Resource_Project = require("../Lunarbox.Capability.Resource.Project/index.js");
var Lunarbox_Component_Error = require("../Lunarbox.Component.Error/index.js");
var Lunarbox_Component_Loading = require("../Lunarbox.Component.Loading/index.js");
var Lunarbox_Data_Route = require("../Lunarbox.Data.Route/index.js");
var Network_RemoteData = require("../Network.RemoteData/index.js");
var Record = require("../Record/index.js");
var Init = (function () {
    function Init() {

    };
    Init.value = new Init();
    return Init;
})();
var component = function (dictManageProjects) {
    return function (dictNavigate) {
        var render = function (v) {
            if (v.newId instanceof Network_RemoteData.Failure) {
                return Lunarbox_Component_Error.error(v.newId.value0);
            };
            return Lunarbox_Component_Loading.loading;
        };
        var handleAction = function (v) {
            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                return v1.targetId;
            }))(function (targetId) {
                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Capability_Resource_Project.cloneProject(Lunarbox_Capability_Resource_Project.manageUserHalogenM(dictManageProjects))(targetId))(function (response) {
                    if (response instanceof Data_Either.Left) {
                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                            var $13 = {};
                            for (var $14 in v1) {
                                if ({}.hasOwnProperty.call(v1, $14)) {
                                    $13[$14] = v1[$14];
                                };
                            };
                            $13.newId = new Network_RemoteData.Failure(response.value0);
                            return $13;
                        });
                    };
                    if (response instanceof Data_Either.Right) {
                        return Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(new Lunarbox_Data_Route.Project(response.value0));
                    };
                    throw new Error("Failed pattern match at Lunarbox.Component.Clone (line 44, column 7 - line 46, column 48): " + [ response.constructor.name ]);
                });
            });
        };
        return Halogen_Component.mkComponent({
            initialState: Record.merge()()({
                newId: Network_RemoteData.NotAsked.value
            }),
            render: render,
            "eval": Halogen_Component.mkEval({
                handleAction: handleAction,
                handleQuery: Halogen_Component.defaultEval.handleQuery,
                receive: Halogen_Component.defaultEval.receive,
                initialize: new Data_Maybe.Just(Init.value),
                finalize: Halogen_Component.defaultEval.finalize
            })
        });
    };
};
module.exports = {
    component: component
};
